import { Component, input } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';
import { CommonModule } from '@angular/common';
import { GridColumn } from '../../classes/column.interface';
/*
  using skeleton with loadingbody template for virtual scroll
  https://stackblitz.com/edit/primeng-tablevirtualscroll-demo-d7i4vj?file=src%2Fapp%2Fapp.component.html
*/
@Component({
  selector: 'app-lt-png-skeleton-row',
  imports: [CommonModule, SkeletonModule],
  standalone: true,
  template: `
    <tr style="{{rowStyle()}}">
      @for(i of [].constructor(totalColumns); track i){
        <td>
          <p-skeleton class="{{skeletonClass()}}"></p-skeleton>
        </td>
      }
      @empty {
        <td>
          <p-skeleton class="{{skeletonClass()}}"></p-skeleton>
        </td>
      }
    </tr>
  `,
  styles: `
  `,
})
export class LTPngSkeletonRowComponent {
  columns = input<GridColumn[] | null>(null);
  count = input<number | null>(null);
  skeletonClass = input<string>('w-100');
  rowStyle = input<string>('height:34px');

  get totalColumns() {
    if (this.count() && this.columns() && this.columns().length > 0) {
      return Math.max(this.count(), this.columns().length);
    }
    else if (this.columns() && this.columns().length > 0) {
      return this.columns().length;
    }
    else if (this.count()) {
      return this.count();
    }

    return 0;
  }
}
